'use client';

import React, {
  createContext,
  useEffect,
  ReactNode,
  useMemo,
} from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { LoggerData } from '@/lib/types/interfaces/LoggerData';
import { sendLoggerData } from '@/lib/api/functions';
import { useVisitedPages } from '@/components/VisitedPagesContext';
import { API_URL } from '../../../constants';

type LoggerContextType = {
  loggerData: LoggerData;
};

const LoggerContext = createContext<LoggerContextType | undefined>(undefined);

type LoggerProviderProps = {
  loggerData: LoggerData;
  children: ReactNode;
};

export const LoggerProvider = ({
  loggerData,
  children,
}: LoggerProviderProps) => {
  const { visitedPages, setVisitedPages } = useVisitedPages();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = searchParams.toString()
      ? `${API_URL}${pathname}?${searchParams.toString()}`
      : `${API_URL}${pathname}`;

    sendLoggerData({ ...loggerData, visitedPages: [...visitedPages, url] });
    setVisitedPages((prev: string[]) => [...prev, url]);
  }, [loggerData]);

  const contextValue = useMemo(() => ({ loggerData }), [loggerData]);

  return (
    <LoggerContext.Provider value={contextValue}>
      {children}
    </LoggerContext.Provider>
  );
};
